import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config/api';
import siteContentStatic from '../data/siteContent.json';

function NotreEquipe() {
  const [data, setData] = useState(siteContentStatic.team);

  useEffect(() => {
    fetch(`${API_BASE}/api/site-content`)
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(content => { if (content.team) setData(content.team); })
      .catch(() => {});
  }, []);

  return (
    <article className="post-10 page type-page status-publish hentry">
      <header className="entry-header">
        <h1 className="entry-title">{data.title}</h1>
      </header>

      <div className="entry-content">
        <p style={{ textAlign: 'justify' }}>{data.intro}</p>

        <ul style={{ textAlign: 'justify' }}>
          {data.members.map((member, i) => (
            <li key={i}>
              {member.role} : <strong>{member.name}</strong>, {member.description}
            </li>
          ))}
        </ul>

        {data.image && (
          <div className="page-image-showcase">
            <img
              src={data.image}
              alt="L'équipe RIVE"
              loading="lazy"
            />
          </div>
        )}

        {data.psychologist && (
          <ul style={{ textAlign: 'justify' }}>
            <li>
              {data.psychologist.role} de l'association{' '}
              <a href={data.psychologist.organizationUrl} target="_blank" rel="noopener noreferrer">
                {data.psychologist.organization}
              </a>{' '}
              : <strong>{data.psychologist.name}</strong>, {data.psychologist.description}
            </li>
          </ul>
        )}

        <p>
          Les bénévoles se relaient tous les jours pour assurer les missions d'accueil et d'accès aux services proposés (2 ou 3 par demi-journée) :
        </p>

        <p>{data.volunteerActivities.morning}</p>
        <p>{data.volunteerActivities.afternoon}</p>
        <p>{data.volunteerActivities.outings}</p>
      </div>
    </article>
  );
}

export default NotreEquipe;
